import pngicon from "../../src/assests/imgs/png.svg";
import pdficon from "../../src/assests/imgs/pdf.svg";
import docicon from "../../src/assests/imgs/doc.svg";
import ppticon from "../../src/assests/imgs/ppt1.svg";
import xlsicon from "../../src/assests/imgs/xlsx.svg";
import zipicon from "../../src/assests/imgs/zip.svg";

const fallbackImage = pdficon;

// 🧩 Get correct icon based on file extension
const getFileIcon = (url) => {
  if (!url) return fallbackImage;
  const ext = url.split(".").pop()?.toLowerCase()?.split("?")[0];
  switch (ext) {
    case "pdf":
      return pdficon;
    case "txt":
    case "doc":
    case "docx":
      return docicon;
    case "ppt":
    case "pptx":
      return ppticon;
    case "xls":
    case "xlsx":
      return xlsicon;
    case "zip":
    case "rar":
    case "7z":
      return zipicon;
    case "png":
      return pngicon;
    default:
      return fallbackImage;
  }
};

// 🧠 Detect if file is an image type
const isImageFile = (url) => {
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "bmp"];
  const ext = url.split(".").pop()?.toLowerCase()?.split("?")[0];
  return imageExtensions.includes(ext);
};

// ✅ Check if image loads properly, else fallback
const handleImageLoadError = (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = url;
    img.onload = () => resolve(url);
    img.onerror = () => resolve(getFileIcon(url));
  });
};

// 🧩 Main function
export const preprocessImages = async (files) => {
  const processedImages = await Promise.all(
    files.map(async (file) => {
      const url = file.file || file.original || file;

      // If not image → return file-type icon
      if (!(url)) {
        const icon = getFileIcon(url);
        return { original: icon, thumbnail: icon, file_url: url || icon };
      }

      // If image → verify it loads correctly
      const validUrl = await handleImageLoadError(url);
      return { original: validUrl, thumbnail: validUrl, file_url: url || validUrl };
    })
  );

  return processedImages;
};
